module.exports = __webpack_public_path__ + "img/success-image.81079165.svg";